import React from 'react'
import { IconType } from 'react-icons';

interface Outlinedbutton {
    onClick?(): void,
    label:string,
    classname?:string,
    icon?: IconType,
  }
const OutlinedButton:React.FC<Outlinedbutton>= ({onClick,label,classname,icon: Icon}) => {
  return (
    <button onClick={onClick} className={classname ? 'p-2 px-4 rounded-[10px] ' + classname : 'bg-[#F4F4F4] p-2 px-4 rounded-[10px]'} >
      <div className='flex justify-center items-center gap-3 mx-auto '>
       {Icon && <Icon style={{strokeWidth:"1.5px"}}/>}<span>{label}</span>
       </div>
       </button>
  )
}

export default OutlinedButton